import proj4 from 'proj4';
import { register } from 'ol/proj/proj4';

// register overrides
proj4.defs("EPSG:4258","+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs");

register(proj4);

